function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

var CharSeq = /*#__PURE__*/function (_String) {
  _inheritsLoose(CharSeq, _String);
  function CharSeq(str) {
    return _String.call(this, str || '') || this;
  }
  return CharSeq;
}( /*#__PURE__*/_wrapNativeSuper(String));
var MaxInt = function MaxInt() {
  return Infinity;
};
function WithFallbackMaskAll() {
  return function (config) {
    config.FallbackMaskAll = true;
  };
}
function Nop(v) {
  return v;
}
function RetainTail(n) {
  for (var _len = arguments.length, opts = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    opts[_key - 1] = arguments[_key];
  }
  return RetainHeadAndTail.apply(void 0, [0, n].concat(opts));
}
function RetainHead(n) {
  for (var _len2 = arguments.length, opts = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    opts[_key2 - 1] = arguments[_key2];
  }
  return RetainHeadAndTail.apply(void 0, [n, 0].concat(opts));
}
function All() {
  return HeadAndTail(0, Infinity);
}
function Head(n) {
  for (var _len3 = arguments.length, opts = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    opts[_key3 - 1] = arguments[_key3];
  }
  return HeadAndTail.apply(void 0, [n, 0].concat(opts));
}
function Tail(n) {
  for (var _len4 = arguments.length, opts = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    opts[_key4 - 1] = arguments[_key4];
  }
  return HeadAndTail.apply(void 0, [0, n].concat(opts));
}
function RetainHeadAndTail(headN, tailN) {
  for (var _len5 = arguments.length, opts = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    opts[_key5 - 2] = arguments[_key5];
  }
  return function (s) {
    var chars = new CharSeq(s || '');
    var count = chars.length;
    var head = putInRange(headN, 0, count);
    var tail = putInRange(tailN, 0, count);
    if (head + tail >= count) {
      var cf = getMaskConfig.apply(void 0, opts);
      if (cf.FallbackMaskAll) {
        return '*'.repeat(count);
      }
      return s;
    }
    return chars.slice(0, head) + '*'.repeat(count - head - tail) + chars.slice(count - tail);
  };
}
function RetainIndex(from, to) {
  return function (s) {
    var chars = new CharSeq(s);
    var count = chars.length;
    var f = putInRange(from, 0, count);
    var t = putInRange(to, 0, count);
    if (f >= t) {
      return '*'.repeat(count);
    }
    return '*'.repeat(f) + chars.slice(f, t) + '*'.repeat(count - t);
  };
}
function Index(from, to) {
  for (var _len6 = arguments.length, opts = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
    opts[_key6 - 2] = arguments[_key6];
  }
  return function (s) {
    var chars = new CharSeq(s);
    var count = chars.length;
    var f = putInRange(from, 0, count);
    var t = putInRange(to, 0, count);
    if (f >= t) {
      var cf = getMaskConfig.apply(void 0, opts);
      if (cf.FallbackMaskAll) {
        return '*'.repeat(count);
      }
      return s;
    }
    return chars.slice(0, f) + '*'.repeat(t - f) + chars.slice(t);
  };
}
function HeadAndTail(headN, tailN) {
  return function (s) {
    var chars = new CharSeq(s);
    var count = chars.length;
    var head = putInRange(headN, 0, count);
    var tail = putInRange(tailN, 0, count);
    if (head + tail >= count) {
      return '*'.repeat(count);
    }
    var retainedMiddle = chars.slice(head, count - tail);
    return '*'.repeat(head) + retainedMiddle + '*'.repeat(tail);
  };
}
function RetainHeadAndTailBySegment(headN, tailN, sep) {
  return function (s) {
    var segs = s.split(sep);
    var count = segs.length;
    var head = putInRange(headN, 0, count);
    var tail = putInRange(tailN, 0, count);
    if (head + tail >= count) {
      return s;
    }
    for (var i = head; i < count - tail; i++) {
      segs[i] = All()(segs[i]);
    }
    return segs.join(sep);
  };
}
function putInRange(i, low, high) {
  if (i < low) {
    return low;
  } else if (i > high) {
    return high;
  } else {
    return i;
  }
}
function getMaskConfig() {
  var cf = {
    FallbackMaskAll: false
  };
  for (var _len7 = arguments.length, opts = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    opts[_key7] = arguments[_key7];
  }
  for (var _i = 0, _opts2 = opts; _i < _opts2.length; _i++) {
    var opt = _opts2[_i];
    opt(cf);
  }
  return cf;
}

var FieldType = {
  Unclear: 'unclear',
  FullName: 'full_name',
  FirstName: 'first_name',
  Mobile: 'mobile',
  Email: 'email',
  Address: 'address',
  Birthday: 'birthday',
  IDNumber: 'id_number',
  BankAccountNo: 'bank_account_no',
  IPAddress: 'ip_address',
  MACAddress: 'mac_address',
  LatLng: 'lat_lng'
};
var validFieldTypeMap = {
  unclear: {},
  full_name: {},
  first_name: {},
  mobile: {},
  email: {},
  address: {},
  birthday: {},
  id_number: {},
  bank_account_no: {},
  ip_address: {},
  mac_address: {},
  lat_lng: {}
};
function IsValidFieldType(ft) {
  return ft in validFieldTypeMap;
}

var _fieldMaskFuncMap, _fieldMaskWithOptFunc;
// const sensitivefield = FieldType.FieldType
var fieldMaskFuncMap = (_fieldMaskFuncMap = {}, _fieldMaskFuncMap[FieldType.Unclear] = function (_s) {
  return '';
}, _fieldMaskFuncMap[FieldType.FullName] = function (s) {
  s = s.trim();
  var spaceIdx = s.indexOf(' ');
  if (spaceIdx > 0) {
    return s.slice(0, spaceIdx + 1) + All()(s.slice(spaceIdx + 1));
  }
  return RetainHead(1, WithFallbackMaskAll())(s);
}, _fieldMaskFuncMap[FieldType.FirstName] = /*#__PURE__*/All(), _fieldMaskFuncMap[FieldType.Email] = function (s) {
  var atIdx = s.indexOf('@');
  if (atIdx < 0) {
    return s;
  }
  return RetainHead(3, WithFallbackMaskAll())(s.slice(0, atIdx)) + s.slice(atIdx);
}, _fieldMaskFuncMap[FieldType.Address] = /*#__PURE__*/RetainHead(4, /*#__PURE__*/WithFallbackMaskAll()), _fieldMaskFuncMap[FieldType.Birthday] = /*#__PURE__*/Head(4), _fieldMaskFuncMap[FieldType.IPAddress] = function (s) {
  if (s.includes('.')) {
    return RetainHeadAndTailBySegment(1, 1, '.')(s);
  }
  if (s.includes(':')) {
    return RetainHeadAndTailBySegment(1, 1, ':')(s);
  }
  return s;
}, _fieldMaskFuncMap[FieldType.IDNumber] = /*#__PURE__*/RetainHeadAndTail(1, 1, /*#__PURE__*/WithFallbackMaskAll()), _fieldMaskFuncMap[FieldType.BankAccountNo] = /*#__PURE__*/RetainTail(4), _fieldMaskFuncMap[FieldType.MACAddress] = function (s) {
  if (s.includes('-')) {
    return RetainHeadAndTailBySegment(1, 1, '-')(s);
  }
  if (s.includes(':')) {
    return RetainHeadAndTailBySegment(1, 1, ':')(s);
  }
  return s;
}, _fieldMaskFuncMap[FieldType.LatLng] = function (s) {
  var items = s.split(',');
  for (var i = 0; i < items.length; i++) {
    items[i] = Index(items[i].indexOf('.') + 1, MaxInt(), WithFallbackMaskAll())(items[i]);
  }
  return items.join(',');
}, _fieldMaskFuncMap);
var defaultMobileMaskFunc = /*#__PURE__*/RetainTail(4); // 默认保留尾4
var mobileMaskFuncMap = {
  '86': /*#__PURE__*/RetainHeadAndTail(3, 4)
};
// 手机号，号码部分CN地区保留头3尾4，其他地区保留尾4. 如：
// 带区号: 86-133****1234, 852-****0505
// 不带区号: 133****1234, ****0505. (不带区号的可通过option额外传区号进来)
function maskMobile(mobile, opt) {
  if (opt === void 0) {
    opt = {
      delimiter: '-'
    };
  }
  var areaCode, phoneNumber;
  var delimiter = opt.delimiter || '-';
  var prefix = opt.prefix || '+';
  var mobileInfo = (mobile || '').split(delimiter);
  if (mobileInfo.length === 2) {
    areaCode = mobileInfo[0];
    phoneNumber = mobileInfo[1];
  } else {
    areaCode = opt.MobileAreaCode;
    phoneNumber = mobile;
  }
  var newAreaCode = '';
  if (prefix && areaCode) {
    newAreaCode = areaCode.replace(new RegExp("^\\" + ("" + prefix)), '');
  }
  var f = mobileMaskFuncMap[newAreaCode] || defaultMobileMaskFunc;
  var masked = f(phoneNumber);
  if (mobileInfo.length === 2) {
    masked = areaCode + "-" + masked;
  }
  return masked;
}
var fieldMaskWithOptFuncMap = (_fieldMaskWithOptFunc = {}, _fieldMaskWithOptFunc[FieldType.Mobile] = maskMobile, _fieldMaskWithOptFunc);
var MaskUtil = /*#__PURE__*/_extends({}, fieldMaskFuncMap, fieldMaskWithOptFuncMap);

export { All, FieldType, Head, HeadAndTail, Index, IsValidFieldType, MaskUtil, MaxInt, Nop, RetainHead, RetainHeadAndTail, RetainHeadAndTailBySegment, RetainIndex, RetainTail, Tail, WithFallbackMaskAll, validFieldTypeMap };
//# sourceMappingURL=klk-kcrypto.esm.js.map
